/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {routeUtils} from "@/shared/route.util";
import {constants} from "@/shared/constants";

export default [
  {
    path: "/login",
    name: "Login",
    view: "Auth/Login",
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    view: "Auth/ForgetPassword",
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    view: "Auth/ResetPassword",
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/email-verification",
    name: "EmailVerification",
    view: "Auth/EmailVerification",
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/",
    name: "Dashboard",
    view: "Dashboard/Dashboard",
  },
  {
    path: "/dashboard/reporting-dashboard",
    name: "ReportingDashboard",
    view: "Dashboard/ReportingDashboard",
  },
  // {
  //   path: "/",
  //   name: "Notifications",
  //   view: "Notifications",
  // },
  {
    path: "/works",
    name: "Works",
    view: "Works/Works",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_PROJECT)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
    childs: [
      {
        path: "detail/:id",
        name: "WorkDetail",
        view: "Works/Detail",
        redirect: { name: 'WorksOverview' },
        childs: [
          {
            path: "overview",
            name: "WorksOverview",
            view: "Works/Overview",
          },
          {
            path: "operations",
            name: "WorksLotOperations",
            view: "Works/OperationsLot",
            childs: [
              {
                path: ":idOperation",
                name: "WorksOperation",
                view: "Works/Operation",
              }
            ]
          },
          {
            path: "documents",
            name: "WorksDocuments",
            view: "Works/Documents",
          },
        ],
      },

    ]
  },{
    path: "/operations",
    name: "Operations",
    view: "Operations/Operations",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_PROJECT)|| routeUtils.isAllowed(constants.VIEW_SIMULATION)) {
        next();
      } else {
        next({ path: "/", replace: true });
      }
    },
    childs: [
      {
        path: "detail/:idOperation",
        name: "OperationDetail",
        view: "Operations/OperationDetail",
        redirect: to => ({
          name: "Operation",                    
          params: { idOperation: to.params.idOperation }
        }),
        childs: [
          {
            path: "",
            name: "Operation",
            view: "Operations/OperationDetail"
          }
        ]
      },
    ]
  },
  {
    path: "/simulations",
    name: "Simulations",
    view: "Simulations/Simulations",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
    childs: [
      {
        path: "detail/:id",
        name: "SimulationDetail",
        view: "Simulations/Detail",
        redirect: { name: 'SimulationsOverview' },
        childs: [
          {
            path: "overview",
            name: "SimulationsOverview",
            view: "Simulations/Overview",
          },
          {
            path: "operations",
            name: "SimulationsOperations",
            view: "Simulations/Operations",
            childs: [
              {
                path: ":idOperation",
                name: "SimulationsOperation",
                view: "Simulations/Operation",
              }
            ]
          },
          {
            path: "documents",
            name: "SimulationsDocuments",
            view: "Simulations/Wizzard/SimulationDocuments",
          },
        ],
      },
    ]
  },
  {
    path: "/simulations/add",
    name: "AddSimulation",
    view: "Simulations/Simulator",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.CREATE_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/simulations/edit/:id",
    name: "EditSimulation",
    view: "Simulations/Simulator",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/simulations/edit/:id/estimations",
    name: "AddEstimations",
    view: "Simulations/AddEstimations",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/simulations/edit/:id/infos",
    name: "SimulationInfos",
    view: "Simulations/SimulationInfos",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/simulations/:id/import-mass",
    name: "SimulationImportMass",
    view: "Simulations/SimulationImportMass",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_SIMULATION)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/reporting",
    name: "Reporting",
    view: "Reporting/Reporting"
  },
  {
    path: "/reglementaire",
    name: "Reglementaire",
    view: "Reglementaire/Reglementaire",
    redirect: { name: 'ReglementaireOverview' },
    childs: [
      {
        path: "articles",
        name: "ReglementaireOverview",
        view: "Reglementaire/ArticlesList",
      },
      {
        path: "downloads",
        name: "ReglementaireDownloads",
        view: "Reglementaire/DocsDownloads",
      },
      {
        path: "article/:id/",
        name: "Article",
        view: "Reglementaire/Article",
      },

    ],
  },
  {
    path: "/contacts",
    name: "Contacts",
    view: "Contacts/Contacts",
  },
  {
    path: "/contracts",
    name: "Contracts",
    view: "Contracts/Contracts",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.VIEW_CONTRACT)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
  },
  {
    path: "/agences",
    name: "Agences",
    view: "Agences/Agences",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAdminAndB2B2B()){
        next()
      } else {
        next({path: '/', replace: true})
      }
    }
  },
  {
    path: "/agences/:id/users",
    name: "TeamAgence",
    view: "Account/Team",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAdminAndB2B2B()){
        next()
      } else {
        next({path: '/', replace: true})
      }
    }
  },
  {
    path: "/team",
    name: "Team",
    view: "Account/Team",
    beforeEnter: (to, from, next) => {
      if (routeUtils.isAllowed(constants.MANAGE_USERS)){
        next()
      } else {
        next({path: '/', replace: true})
      }
    },
    childs: [
      {
        path: "roles",
        name: "Roles",
        view: "Account/Roles",
        beforeEnter: (to, from, next) => {
          if (routeUtils.isAdmin()){
            next()
          } else {
            next({path: '/', replace: true})
          }
        }
      },
      // {
      //   path: "",
      //   name: "Users",
      //   view: "Account/Users",
      // }
    ]
  },
  {
    path: "/account",
    name: "Account",
    view: "Account/Account",
    redirect: 'account/users',
    childs: [
      {
        path: 'profile',
        name: 'Profile',
        view: 'Account/Profile'
      },
      // {
      //   path: 'security',
      //   name: 'Security',
      //   view: 'Account/Security'
      // },
      {
        path: 'notifications',
        name: 'AccountNotifications',
        view: 'Account/Notifications'
      },
      {
        path: 'email',
        name: 'AccountEmail',
        view: 'Account/Email'
      },
      {
        path: 'users',
        name: 'Users',
        view: 'Account/Users',
        beforeEnter: (to, from, next) => {
          if (routeUtils.isAllowed(constants.MANAGE_USERS)){
            next()
          } else {
            next({path: '/', replace: true})
          }
        },
      },
      // {
      //   path: 'roles',
      //   name: 'Roles',
      //   view: 'Account/Roles',
      //   beforeEnter: (to, from, next) => {
      //     if (routeUtils.isAllowed(constants.MANAGE_USERS)){
      //       next()
      //     } else {
      //       next({path: '/', replace: true})
      //     }
      //   },
      // },

    ]
  },{
    path: "/impersonate",
    name: "Impersonate",
    view: "Impersonate/Impersonate",
    meta: {
      layout: "auth",
    }
  },
  {
    path: "/components",
    name: "Components",
    view: "Components/Components",
  },
  {
    path: '/notifications',
    name: 'Notifications',
    view: 'Notifications'
  },
  {
    path: "/*",
    name: "Error404",
    view: "Error/404",
  }
];
